import { getValidPhoneNumberFromUrl } from './getValidPhoneNumberFromUrl'

export const removeKeyFromUrl = (navigate: (url: string) => void) => {
  const phoneNumber = getValidPhoneNumberFromUrl(window.location.pathname)

  if (!phoneNumber) return

  const url = new URL(window.location.href.replace(`/${phoneNumber}`, ''))
  url.searchParams.delete('key')

  navigate(url.pathname + url.search)
}
